import React, { useState, useEffect } from 'react';
import { useInstallPrompt } from '../hooks/useInstallPrompt';

const InstallButton: React.FC = () => {
  const { isInstallable, isInstalled, installApp } = useInstallPrompt();
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkIsMobile = () => {
      setIsMobile(window.innerWidth < 768); // md breakpoint
    };

    checkIsMobile();
    window.addEventListener('resize', checkIsMobile);
    return () => window.removeEventListener('resize', checkIsMobile);
  }, []);

  // Don't show button if app is already installed, not installable, or not on mobile
  if (isInstalled || !isInstallable || !isMobile) {
    return null;
  }

  return (
    <button
      onClick={installApp}
      data-testid="install-btn"
      className="px-3 py-1.5 bg-transparent border border-green-600 text-green-600 rounded-md
                 font-medium text-xs hover:bg-green-50 hover:border-green-700 hover:text-green-700
                 transition-all active:scale-95 flex items-center gap-1"
      title="Install this app on your device"
    >
      <svg
        className="w-3 h-3"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M12 4v16m8-8H4"
        />
      </svg>
      Install
    </button>
  );
};

export default InstallButton;